<h1>MODELO DE PREVENCIÓN DE DELITOS</h1>

<div class="text-center">
    <div class="btn-group">
      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option1"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('2020 01 06 Modelo Prevención -4a7febfc3f97145f.pdf')"
      />
      <label class="btn btn-secondary" for="option1">MODELO DE PREVENCIÓN DE DELITOS</label>
  
      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option2"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('2020 01 06 Código de Ética Garibaldi vf.pdf')"
      />
      <label class="btn btn-secondary" for="option2">CÓDIGO DE ÉTICA</label>
  
      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option3"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('2020 01 06 Lanzamiento Modelo-f48b342a52ece038.pdf')"
      />
      <label class="btn btn-secondary" for="option3">PRESENTACION</label>
    </div>
  </div> 



  <div class="pdf-container">
    <iframe [src]="pdfSrc" width="100%" height="720px"></iframe>
  </div>
